// Modules
import { gql } from '@apollo/client'

export const MessageChangePassword = gql`
    mutation messageChangePassword($username: String!, $contact: ContactTypes, $logInfo: LogInfoInput) {
        messageChangePassword(username: $username, contact: $contact, logInfo: $logInfo) {
            message
            phone
            email
        }
    }
`
export const ChangePassword = gql`
    mutation changePassword($username: String!, $token: String!, $newPassword: String!, $logInfo: LogInfoInput) {
        changePassword(username: $username, token: $token, newPassword: $newPassword, logInfo: $logInfo) {
            message
        }
    }
`

export const CheckToken = gql`
    mutation checkToken($patientToken: PatientToken!) {
        checkToken(patientToken: $patientToken) {
            message
        }
    }
`

export const SendResetToken = gql`
    mutation sendResetToken($resetInput: ResetInput!, $logInfo: LogInfoInput) {
        sendResetToken(resetInput: $resetInput, logInfo: $logInfo) {
            status
        }
    }
`

export const SendOTPToken = gql`
    mutation generateKeyOtp($generateOtpInput: GenerateOtpInput!, $logInfo: LogInfoInput) {
        generateKeyOtp(generateOtpInput: $generateOtpInput, logInfo: $logInfo) {
            key
        }
    }
`

export const CheckOTPToken = gql`
    mutation authenticateOtp($key: String!, $password: String!, $cpf: String!, $logInfo: LogInfoInput) {
        authenticateOtp(key: $key, password: $password, cpf: $cpf, logInfo: $logInfo) {
            access_token
            refresh_token
        }
    }
`
